$(document).ready(function () {
  const projectsAchSlider = new Swiper('.project-achievements-slider', {
    navigation: {
      nextEl: '.project-achievements .swiper-btn-next',
      prevEl: '.project-achievements .swiper-btn-prev',
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 8,
            centeredSlides: true,
            centeredSlidesBounds: true
        }
      },
        watchSlidesVisibility: true,
        setWrapperSize: true,
        allowTouchMove: true
  });
})
$(document).ready(function () {
    const historyInfoSwiper = new Swiper(".YearsInfoSwiper", {
        spaceBetween: 0,
        slidesPerView: 1,
        freeMode: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        effect: "fade",
    });
    const historyYearsSwiper = new Swiper(".yearsSwiper", {
        direction: "vertical",
        spaceBetween: 0,
        slidesPerView: 5,
        thumbs: {
            swiper: historyInfoSwiper,
        },
        mousewheel: true,
        centeredSlides: true,
        freeMode: true,
        slideToClickedSlide: true
    });
})
$(document).ready(function () {
    const membersTagList = $("#members-list").find("li");
    const membersDescsList = $(".main-info__members-desc");

    membersTagList.click(changeParticipantsGroup);

    function changeParticipantsGroup(ev) {
        const tag = $(event.target);
        const id = tag.data('id');
        membersTagList.removeClass('active');
        tag.addClass('active');
        membersDescsList.addClass('main-info__members-desc_hidden');
        membersDescsList.filter(`[data-id="${id}"]`).removeClass('main-info__members-desc_hidden');
    }

    if (!!document.getElementById("mainInfoAccordion")) {
        const accordion = document.getElementById("mainInfoAccordion");
        const accordionItems = accordion.querySelectorAll(".accordion-item");

        $(window).resize(resizeHandler);

        accordionItems.forEach((item) => {
            const btn = item.querySelector('.accordion-item__btn-area');
            btn.addEventListener('click', setActiveAccordionItem);
        });

        function resizeHandler() {
            closeAccordionItems();
        }

        function closeAccordionItems() {
            accordionItems.forEach(item => {
                item.classList.remove('accordion-item_active');
            });
        }

        function setActiveAccordionItem(event) {
            const span = event.currentTarget;
            const accordionItem = span.closest('.accordion-item');
            closeTabsExceptOne(accordionItem.id);
        }

        function closeTabsExceptOne(accordionItemId) {
            accordionItems.forEach(item => {
                if (item.id === accordionItemId) {
                    item.classList.toggle('accordion-item_active');
                } else {
                    item.classList.remove('accordion-item_active');
                }
            });
        }

        resizeHandler();
    }
})
$(document).ready(function () {
    const projectsNewsSlider = new Swiper('.project-news-slider', {
        navigation: {
            nextEl: '.project-news-block .swiper-btn-next',
            prevEl: '.project-news-block .swiper-btn-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 'auto',
                spaceBetween: 0,
                centeredSlides: true,
                centeredSlidesBounds: false
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 32,
                centeredSlides: false,
                centeredSlidesBounds: false
            },
            1600: {
                slidesPerView: 3,
                spaceBetween: 32,
                centeredSlides: false,
                centeredSlidesBounds: false
            }
        },
        watchSlidesVisibility: true,
        setWrapperSize: true,
        allowTouchMove: true
    });

    const partnersBlock = document.querySelector(".projectPage-partners__wrapper");
    const galleryBlock = document.querySelector("section.project-gallery");
    const newsBlock = document.querySelector("section.project-news-block")

    if (!partnersBlock && galleryBlock && newsBlock) {
        newsBlock.classList.add("no-pt-mobile");
    }
})
const onPage = window.innerWidth > 1158 ? 12 : (window.innerWidth > 766) ? 8 : 4

function showPartnerLogos(n) {
    let slides = document.getElementsByClassName("partners_logo");
    let dotsList = [];
    
    if (!(onPage >= slides.length)) {
        for (let i = 0; i < (slides.length / onPage); i++) {
            dotsList.push(`<div class="partners_btn partners_ring" onclick="showPartnerLogos(${i + 1})"><div></div></div>`)
        }
    }

    if (document.getElementById("partners_buttons")) {
        document.getElementById("partners_buttons").innerHTML = dotsList.join('');
    }
    let dots = document.getElementsByClassName("partners_btn");

    for (let i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
    }

    for (let i = 0; i < dots.length; i++) {
        dots[i].className = "partners_btn partners_ring";
    }

    for (let i = 0; i < onPage; i++) {
        if (slides[onPage * (n - 1) + i]) {
            slides[onPage * (n - 1) + i].style.display = "flex";
        }
    }

    if (!!(dots[n - 1])) {
        dots[n - 1].className = "partners_btn partners_selectCircle";
        dots[n - 1].innerHTML = '<div class="partners_selectCircleIn"></div>';
    }
}

showPartnerLogos(1);


$('[data-fancybox]').fancybox({
    buttons: [
        "close"
    ],
    hash: false,
    idleTime: false,
    animationEffect: false,
    arrows: true,
    baseTpl:
        `<div class="fancybox-container fancybox-project-gallery" role="dialog" tabindex="-1">
                <div class="fancybox-bg"></div>
                <div class="fancybox-inner">
                    <div class="fancybox-toolbar">{{buttons}}</div>
                    <div class="fancybox-infobar">
                        <button data-fancybox-prev class="button-prev gallery-btn"><img src="/images/assets/gallery-arrow.svg"></button>
                        <div class="fancybox-info">
                            <span data-fancybox-current></span>
                            <span class="splitter"></span>
                            <span data-fancybox-total></span>
                        </div>
                        <button data-fancybox-next class="button-next gallery-btn"><img src="/images/assets/gallery-arrow.svg"></button>
                    </div>
                    <div class="fancybox-stage"></div>
                </div>
            </div>`,
    onActivate: function (instance) {
        $('[data-fancybox-total]').html(instance.group.length < 10 ? '0' + instance.group.length : instance.group.length);
    },
    afterShow: function (instance, current) {
        $('[data-fancybox-current]').html(current.index < 9 ? '0' + (current.index + 1) : (current.index + 1));
    }
});
$(document).ready(function () {
    if (document.getElementsByClassName('review-slider').length) {
        const filtersTabs = document.getElementById('review-tabs__filters');
        const filtersBody = document.getElementById('review-tabs__body');
        const currentSlide = document.getElementById('current-slide');
        const totalSlides = document.getElementById('total-slides');

        function setTotalSlides(slider) {
            if (slider) {
                const slidesLength = slider.slides.length;
                if (slider.activeIndex < 10) {
                    totalSlides.innerHTML = '0' + slidesLength;
                } else {
                    totalSlides.innerHTML = slidesLength;
                }
            }
        }

        function setCurrentSlideIndex(slider) {
            if (slider) {
                if (slider.activeIndex < 10) {
                    currentSlide.innerHTML = '0' + (slider.activeIndex + 1);
                } else {
                    currentSlide.innerHTML = slider.activeIndex + 1;
                }
            }
        }

        const reviewSwiper = new Swiper('.review-slider', {
            observer: true,
            observeParents: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                init: (slider) => {
                    if (totalSlides.innerHTML.length > 0) {
                        return false;
                    }
                    setTotalSlides(slider);
                },
                slideChange: (slider) => {
                    setCurrentSlideIndex(slider)
                }
            }
        });

        filtersTabs.addEventListener('click', (e) => {
            if (e.target.className === 'review-tabs__filter') {
                for (let i = 0; i < filtersTabs.children.length; i++) {
                    filtersTabs.children[i].classList.remove('active');
                    filtersBody.children[i].classList.remove('active');
                }

                e.target.classList.add('active');
            }

            if (!!document.getElementById(`tab-${e.target.dataset.id}`)) {
                document.getElementById(`tab-${e.target.dataset.id}`).className += ' active';
            }

            setTimeout(() => {
                setTotalSlides(reviewSwiper[e.target.dataset.id]);
                setCurrentSlideIndex(reviewSwiper[e.target.dataset.id]);
            }, 100);

        });
    };
})
$(document).ready(function () {
    const raisedDiv = document.querySelector('.supportProject__weHave');
    const totalDiv = document.querySelector('.supportProject__total');

    if (raisedDiv && totalDiv) {
        try {
            const raisedMoney = raisedDiv.innerHTML.replace(/\s/g, '');
            const totalMoney = totalDiv.innerHTML.replace(/\s/g, '');

            raisedDiv.innerHTML = preformateSum(raisedMoney)
            totalDiv.innerHTML = preformateSum(totalMoney)
        } catch (error) {
            console.log('Error formatting money:', error);
        }
    }
});

function preformateSum(sum) {
    const currencySymbol = ' &#8372;';
    return sum.replace(/\B(?=(\d{3})+(?!\d))/g, " ") + currencySymbol;
}
$(document).ready(function () {
    const stagesInfoTiming = document.getElementsByClassName("timing-stage-info");
    const arrowsBlockTiming = document.getElementById("timing__slider-navigation");
    const rightArrowTiming = document.getElementById("timing__right-button");
    const leftArrowTiming = document.getElementById("timing__left-button");
    const containerTiming = document.getElementById("timing__content");
    const wrapperTiming = document.getElementById("timing__content-wrapper");
    let rightTransform;
    let translate;

    if (stagesInfoTiming) {
        const stages = Array.from(stagesInfoTiming).map((el) => JSON.parse(el.innerText));
        let circleRadius = window.innerWidth > 766 ? 80 : 60;

        function createTimeline() {
            let length = 0;
            translate = 0;
            let elements = [];
            let todayInTimeline = false;
            containerTiming.style["padding"] = `${circleRadius / 2}px`;
            if (stages) {
                for (let i = 0; i < stages.length; i++) {
                    const dateTo = new Date(stages[i].dateTo.slice(0, 10));
                    const dateFrom = new Date(stages[i].dateFrom.slice(0, 10));
                    const today = new Date(new Date().toISOString().slice(0, 10));
                    const periodLength = (dateTo - dateFrom) / 86400000;
                    const dayFromStart = (today - dateFrom) / 86400000;
                    let todayInPeriod = false;
                    let dayAfter = false;
                    if (today >= dateFrom && today <= dateTo) {
                        if (periodLength > 4) {
                            todayInPeriod = dayFromStart === 0
                                ? 1 : dayFromStart / periodLength <= 0.4
                                    ? 2 : dayFromStart / periodLength <= 0.6
                                        ? 3 : dayFromStart / periodLength < 1
                                            ? 4 : 5;
                        } else {
                            todayInPeriod = 3;
                            if (today.toISOString() === dateFrom.toISOString()) {
                                todayInPeriod = 1;
                            }
                            if (today.toISOString() === dateTo.toISOString()) {
                                todayInPeriod = 5;
                            }
                        }

                        todayInTimeline = true;
                        translate = -length;
                    }
                    if (
                        today > dateTo &&
                        stages[i + 1] &&
                        today < new Date(stages[i + 1].dateFrom.slice(0, 10))
                    ) {
                        dayAfter = true;
                        todayInTimeline = true;
                        translate = -(length + 2 * circleRadius);
                    }
                    let backColor = `#${stages[i].color}`;
                    if (todayInPeriod === 2) {
                        backColor = `linear-gradient(90deg, #${stages[i].color} 25%, #${stages[i].color}cf 0%)`;
                    } else if (todayInPeriod === 3) {
                        backColor = `linear-gradient(90deg, #${stages[i].color} 50%, #${stages[i].color}cf 0%)`;
                    } else if (todayInPeriod === 4) {
                        backColor = `linear-gradient(90deg, #${stages[i].color} 75%, #${stages[i].color}cf 0%)`;
                    }
                    if (periodLength === 0) {
                        elements.push(`<div class="figure-wrapper" id='${todayInPeriod ? "today" : ""}' style=margin:${circleRadius / 2}px>
                            <div class="figure-single">
                                 <div class=${todayInPeriod ? "verticalLine_center" : ""} style=background:#${stages[i].color}></div>
                                      <div class=${dayAfter ? "verticalLine" : ""} style=background:#${stages[i].color};left:${2.5 * circleRadius}px></div>
                                      <div class="dateBox_center" style="background:#${stages[i].color}" >
                                         <p class="textDay">${dateTo.getDate()}</p>
                                         <p class="textMonth">${stages[i].toMonthTranslated}</p>
                                         <p class="textYear">${dateTo.getFullYear()}</p>
                                      </div>
                                   </div>
                                   <div class="description-single">
                                      <p>${stages[i].description}</p>
                                   </div>
                                </div>`);
                        length += circleRadius * 3;
                    } else {
                        elements.push(`<div class="figure-wrapper" id='${todayInPeriod ? "today" : ""}' style=margin:${circleRadius / 2}px>
                                   <div class="figure-double"  style="background:${backColor}">
                                      <div class="dateBox_left" >
                                         <p class="textDay">${dateFrom.getDate()}</p>
                                         <p class="textMonth">${stages[i].fromMonthTranslated}</p>
                                         <p class="textYear">${dateFrom.getFullYear()}</p>
                                      </div>
                                      <div class=${todayInPeriod ? "verticalLine" : ""} style=background:#${stages[i].color};left:${Math.max(0, circleRadius * (todayInPeriod - 1))}px></div>
                                      <div class="dateBox_right"  >
                                         <p class="textDay">${dateTo.getDate()}</p>
                                         <p class="textMonth">${stages[i].toMonthTranslated}</p>
                                         <p class="textYear">${dateTo.getFullYear()}</p>
                                      </div>
                                    <div class=${dayAfter ? "verticalLine" : ""} style=background:#${stages[i].color};left:${4.5 * circleRadius}px></div>
                                   </div>
                                   <div class="description-double">
                                      <p>${stages[i].description}</p>
                                   </div>
                                </div>`);
                        length += circleRadius * 5;
                    }
                }
                containerTiming.innerHTML = elements.join(" ");
                let rightTransformValue = - (length - circleRadius * (Math.floor(window.innerWidth / circleRadius) - 1));
                rightTransform = `translateX(${rightTransformValue}px)`;
                if (todayInTimeline) {
                    if (window.innerWidth > 766) {
                        arrowsBlockTiming.style.display = 'flex'
                        translate += circleRadius * 6;
                        if (translate < rightTransformValue) {
                            translate = rightTransformValue
                        }
                        if (length < containerTiming.offsetWidth) {
                            translate = 0
                            arrowsBlockTiming.style.display = 'none'
                        }
                        containerTiming.style.transform = "translateX(" + translate + "px" + ")";
                    } else {
                        arrowsBlockTiming.style.display = 'none'
                        setTimeout(() => wrapperTiming.scrollTo({
                            left: -translate
                        }), 0);
                    }
                } else {
                    containerTiming.style.transform = "translateX(0px)";
                }
            }
            checkArrows();
        }
        createTimeline();

        function nextStage() {
            if (containerTiming.style.transform !== rightTransform) {
                translate -= circleRadius;
                containerTiming.style.transform = "translateX(" + translate + "px" + ")";
            }
            checkArrows();
        }
        function prevStage() {
            if (containerTiming.style.transform !== "translateX(0px)") {
                translate += circleRadius;
                containerTiming.style.transform = "translateX(" + translate + "px" + ")";
            }
            checkArrows();
        }
        function checkArrows() {
            if (containerTiming.style.transform !== rightTransform) {
                rightArrowTiming.classList.remove("opacityArrow");
            } else {
                rightArrowTiming.classList.add("opacityArrow");
            }
            if (containerTiming.style.transform !== "translateX(0px)") {
                leftArrowTiming.classList.remove("opacityArrow");
            } else {
                leftArrowTiming.classList.add("opacityArrow");
            }
        }

        rightArrowTiming.addEventListener("click", nextStage, true);
        leftArrowTiming.addEventListener("click", prevStage, true);
        window.addEventListener("resize", function () {
            if (window.innerWidth > 766) {
                circleRadius = 80;
            } else {
                circleRadius = 60;
            }
            createTimeline();
        },
            true
        );

    }
})
